// Prompt 28 C — brand assets served from /public.
export function Logo({ dark = false, className = "h-7 sm:h-8", testid = "brand-logo" }) {
  return (
    <img src={dark ? "/logo-horizontal-dark@2x.png" : "/logo-horizontal@2x.png"}
         alt="Lingua Franca" className={`w-auto ${className}`} data-testid={testid} />
  );
}

export function Mark({ dark = false, size = 24, testid = "brand-mark" }) {
  return (
    <img src={dark ? "/mark-dark-512.png" : "/mark-512.png"} alt="Lingua Franca"
         width={size} height={size} data-testid={testid} />
  );
}
